import React, { useState, useEffect } from "react";
import GoBack from "../../sub-components/GoBack";
import { FormGrid } from "../../Users/AddANewUser";
import Input from "../../../Input";
import Select from "../../../Select";
import TextArea from "../../../TextArea";
import toast from "react-hot-toast";
import { StockService } from "../../../../services/StockService";
import { useNavigate } from "react-router";
import {
  YieldUpload
} from "../../sub-components/DocumentUploads";
import {YieldService} from "../../../../services/YieldService";
import CsvFormatHint, { YIELD_COLUMNS } from "../sub-components/CsvFormatHint";
const AddYield = () => {
  const navigate=useNavigate();
  const [state, setState] = useState({
    rangeId: 0,
    concessionId: 0,
    speciesId:0,
    compartmentId: 0,
    description: "",
    yieldQuantity: "",
    yield: ""
  });

  const [concessions, setConcessions] = useState([]);
  const [compartments, setCompartments] = useState([]);
  const [species, setSpecies] = useState([]);
  const loadConcessionList = () => {
    StockService.GetAllConcessions().then((res) => {
      let data = res.map((country)=>{
        country.value = country.concessionId;
        country.label = country.concessionName;
        return country;
     })
      // data.unshift({value:0,label:"Make Selection"});
      
         setConcessions(data);
        //  console.log(concessions);
       
    });
  };
  useEffect(() => {
    loadConcessionList();
  }, []);


  const loadSpeciesList = () => {
    YieldService.GetRanges().then((res) => {
      let data = res.map((country)=>{
        country.value = country.yieldVolumeRangeId;
        country.label = country.rangeName;
        return country;
     })
         setSpecies(data);
        //  console.log(concessions);
       
    });
  };
  useEffect(() => {
    loadSpeciesList();
  }, []);


  const handleChange = (e) => {
    const { value, id } = e.target;
    setState((oldState) => ({ ...oldState, [id]: value }));
    if(id === 'concessionId'){
      let compactmentList = concessions.find(c=>c.concessionId === parseInt(e.target.value)); 
   
      if(compactmentList.compartments.length>0){
        let data = compactmentList.compartments.map((country)=>{
              country.value = country.compartmentId;
              country.label = country.compartmentName;
              return country;
          })
          console.log(data)
       setCompartments(data)
      }
     
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!(state.yield instanceof File)) {
      toast.error("Attach the yield CSV file.");
      return;
    }
    if (!/\.csv$/i.test(state.yield.name)) {
      toast.error(`The yield document must be a .csv file (${state.yield.name} isn't). Save it from Excel as CSV and try again.`, { duration: 8000 });
      return;
    }
    const toastId = toast.loading(`Saving yield ...`);
    YieldService.UploadYield(
      state.yield,
      state.compartmentId,
      state.concessionId,
        state.description,
        parseInt(state.rangeId) || 0,
        parseFloat(state.yieldQuantity) || 0,


    )
      .then((res) => {
         toast.dismiss(toastId);
        if (res && res.isSuccessful) {
          toast.success(res.message);
          navigate('/dashboard/stock-management/yield')

        } else {
          const nothingSaved = res && /failed to save data/i.test(res.message || "");
          toast.error(
            nothingSaved
              ? "Nothing was saved: no rows could be read from the file. Check it is a .csv with the column headers shown on the form."
              : (res && res.message) || "An error occurred. Please try again later",
            { duration: 8000 }
          );
        }
      })
      .catch((err) => {
        // console.error(err);
      });
  };


  const [files] = useState([]);
  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    console.log(files);
  }, [files]);

  return (
    <form className="flex flex-col w-full" onSubmit={handleSubmit}>
      <GoBack />
      <h2 className="my-2 text-xl font-medium text-gray-700 ">New Yield Upload</h2>
      <FormGrid>

        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Concession</span>
          
          <Select
            placeholder="Concession"
            type="text"
            value={state.concessionId}
            options={concessions}
            onChange={handleChange}
            required
            id="concessionId"
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Compartment</span>
          <Select
            placeholder="Compartment"
            type="text"
            label="Select A Compartment"
            value={state.compartmentId}
            options={compartments}
            onChange={handleChange}
            required
            id="compartmentId"
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Range (optional)</span>
          <Select
            placeholder="Species"
            type="text"
            label="Select A Range"
            value={state.rangeId}
            options={species}
            onChange={handleChange}
            id="rangeId"
          />
        </label>

        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Yield Quantity</span>
          <Input
            placeholder="Yield Quantity"
            type="number"
            step="any"
            min="0"
            value={state.yieldQuantity}
            onChange={handleChange}
            required
            id="yieldQuantity"
          />
        </label>
        <label className="block">
          <span className="block mb-3 text-gray-700 text-md">Description</span>
          <TextArea
            placeholder="Description"
            type="text"
            value={state.description}
            onChange={handleChange}
            id="description"
          />
        </label>
      </FormGrid>
      <h3 className="my-2 text-lg font-medium text-gray-700 ">Yield Document</h3>
      <CsvFormatHint columns={YIELD_COLUMNS} templateName="yield-template.csv" />
      {/*<TreeDropzone files={files} setFiles={setFiles}/>*/}
      <YieldUpload preview={state.yield}  docname="yield" state={state}/>
      <button
        type="submit"
        className="w-full sm:w-auto sm:px-3 bg-[#3e7c17] hover:bg-[#356C14] text-white font-semibold py-2 lg:py-3 my-3 rounded rounded-md self-end"
      >
        Create Yield
      </button>
    </form>
  );
};

export default AddYield;
